
export interface AssistantTargetResponse {
  target_code?: string;
  target_type?: 'location' | 'image' | 'random';
  target_url?: string;
  message: string;
}

// Enhanced regex patterns to detect reveal requests - must match edge function patterns
export const isRevealRequest = (message: string): boolean => {
  const revealPatterns = [
    /\breveal\s+target\b/i,
    /\breveal\s+the\s+target\b/i,
    /\bshow\s+target\b/i,
    /\bshow\s+the\s+target\b/i,
    /\breveal\b/i,
    /\bshow\s+(?:the\s+)?target\b/i,
    /\bwhat\s+(?:is\s+)?(?:the\s+)?(?:target|image)\b/i,
    /\bdisplay\s+(?:the\s+)?target\b/i,
    /\bopen\s+(?:the\s+)?target\b/i,
    /\btarget\s+reveal\b/i,
    /\bshow\s+(?:me\s+)?(?:the\s+)?(?:image|location|map)\b/i,
    /\bwhat\s+(?:does\s+)?(?:the\s+)?(?:target\s+)?(?:look\s+like|appear)\b/i
  ];

  console.log('🔍 revealUtils: Checking if message is reveal request:', message);
  const isReveal = revealPatterns.some(pattern => pattern.test(message.trim()));
  console.log('🔍 revealUtils: Is reveal request:', isReveal);
  
  return isReveal;
};

// Parse JSON response from Assistant
export const parseAssistantResponse = (content: string): AssistantTargetResponse | null => {
  try {
    console.log('🔍 revealUtils: Parsing assistant response for JSON:', content);
    
    // Look for JSON blocks in the response
    const jsonMatch = content.match(/```json\s*([\s\S]*?)\s*```/) || content.match(/\{[\s\S]*?\}/);
    
    if (jsonMatch) {
      const jsonStr = jsonMatch[1] || jsonMatch[0];
      console.log('🔍 revealUtils: Found JSON string:', jsonStr);
      
      const parsed = JSON.parse(jsonStr);
      console.log('🔍 revealUtils: Parsed JSON:', parsed);
      
      // Validate that it contains target information
      if (parsed.target_code && parsed.target_type && parsed.target_url) {
        return parsed as AssistantTargetResponse;
      }
    }
    
    return null;
  } catch (error) {
    console.log('🔍 revealUtils: Failed to parse JSON, not a target response:', error);
    return null;
  }
};

// Extract target code from text
export const extractTargetCode = (text: string): string | null => {
  const codePatterns = [
    /target code (?:is:?\s*)?([A-Z0-9]{4}-[A-Z0-9]{4})/i,
    /target code:?\s*([A-Z0-9]{8})/i,
    /code:?\s*([A-Z0-9]{4}-[A-Z0-9]{4})/i,
    /code:?\s*([A-Z0-9]{8})/i,
    /([A-Z0-9]{4}-[A-Z0-9]{4})/g,
    /\b([A-Z0-9]{8})\b/g
  ];
  
  for (const pattern of codePatterns) {
    const match = text.match(pattern);
    if (match && match[1]) {
      return match[1];
    }
  }
  
  return null;
};
